import { render, staticRenderFns } from "./historyOrder.vue?vue&type=template&id=820e6ec2&scoped=true"
import script from "./historyOrder.vue?vue&type=script&lang=js"
export * from "./historyOrder.vue?vue&type=script&lang=js"
import style0 from "./historyOrder.vue?vue&type=style&index=0&id=820e6ec2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820e6ec2",
  null
  
)

export default component.exports